var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAwsS3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5982 10.3084L37.2898 28.028L46.5982 45.7477L50.4113 43.6168V12.4393L46.5982 10.3084Z",
    fill: "#E25444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5981 10.3084L27.9813 12.4393L18.5046 28.028L27.9813 43.6168L46.5981 45.7477V10.3084Z",
    fill: "#7B1D13"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02804 10.3084L6 11.6542V44.4019L9.02804 45.7477L27.9813 28.028L9.02804 10.3084Z",
    fill: "#58150D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9873 10.2711L28.0064 15.5545V40.975L8.9873 45.7601V10.2711Z",
    fill: "#E25444"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0165 18.3458L19.9408 17.0498L28.0165 7.87846L36.0722 17.0498L28.0165 18.3458Z",
    fill: "#58150D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0722 17.0498L28.0065 18.3657L19.9408 17.0498V7.87846",
    fill: "#58150D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0165 37.5856L19.9408 39.081L28.0165 46.9564L36.0722 39.081L28.0165 37.5856Z",
    fill: "#58150D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9813 1L19.9065 5.26168V17.0374L28.0064 14.757L27.9813 1Z",
    fill: "#7B1D13"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0065 21.2367L19.9408 22.1141V33.8716L28.0065 34.7944V21.2367Z",
    fill: "#7B1D13"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0065 41.0747L19.9408 39.0523V50.6108L28.0065 54.8318V41.0747Z",
    fill: "#7B1D13"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0722 39.0523L28.0065 41.0753V54.8318L36.0722 50.6108V39.0523Z",
    fill: "#E25444"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0065 21.2367L36.0722 22.1141V33.8716L28.0065 34.7944V21.2367Z",
    fill: "#E25444"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9813 1L36.0561 5.26168V17.0374L27.9813 14.7944V1Z",
    fill: "#E25444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwsS3);
export default __webpack_public_path__ + "static/media/icon-aws-s3.c0a485a7a390de1243dfccb8634bef6c.svg";
export { ForwardRef as ReactComponent };